export const UNSUPPORTED_LIST_URLS: string[] = []
export const DEFAULT_LIST_OF_LISTS: string[] = []
export const DEFAULT_ACTIVE_LIST_URLS: string[] = []
